<template>
  <div ref="accordion" data-opened="false" class="c-base-accordion-wallet">
    <div @click="toogle" class="c-base-accordion-wallet__header">
      <p>
        {{ label }}<br />
        <strong :class="color" class="c-base-accordion-wallet__title">
          {{ prefix }} {{ value }}
        </strong>
      </p>
      <i class="icon c-base-accordion-wallet__arrow">
        <base-icon name="painel/chevron-up-icon" />
      </i>
    </div>
    <div class="c-base-accordion-wallet__body">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },

    value: {
      type: String,
    },

    color: {
      type: String,
    },

    prefix: {
      type: String,
    },
  },

  methods: {
    toogle() {
      const accordions = document.getElementsByClassName(
        'c-base-accordion-wallet'
      )
      const self = this.$refs.accordion
      const opened = self.getAttribute('data-opened')

      for (const accordion of accordions) {
        accordion.classList.remove('c-base-accordion-wallet--active')
        if (accordion !== self) accordion.setAttribute('data-opened', 'false')
      }

      if (opened === 'false') {
        self.classList.add('c-base-accordion-wallet--active')
        self.setAttribute('data-opened', 'true')
      } else self.setAttribute('data-opened', 'false')
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-accordion-wallet {
  padding: 0.8em 1em;
  border-bottom: 2px solid $gray-3;
  transition: 0.2s all ease-in-out;
  &:hover {
    background-color: rgba($gray-6, 0.05);
  }

  @media (min-width: $tablet) {
    border-width: 1px;
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__arrow {
    @include position(absolute, 50%, 12px, auto, auto, -50%);
    padding-top: 5px;

    > svg {
      transition: 0.5s all ease-in-out;
      transform: rotate(180deg);
    }
  }

  &__title {
    font-size: 20px;
  }

  &__body {
    max-height: 0;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transition: 0.5s all ease-in;
  }

  &--active {
    .c-base-accordion-wallet {
      &__arrow > svg {
        transform: none;
      }

      &__body {
        max-height: 100vh;
        padding: 0.5em 0;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>
